// extracted by mini-css-extract-plugin
export default {"button":"destructive__button___T+kfY primary__button___frFdc base__button___zT0JW"};